let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jtSGU")).then(() => parcelRequire('v17He'));